import useSWR from "swr"

const fetcher = (url: string) =>
    fetch(url, { method: "POST", credentials: "include" }).then(res => res.json())

export function useSWRCentraSession() {
    const { data, error, isLoading } = useSWR(
        "/api/get-centra-session-from-cookies",
        fetcher
    )

    return {
        centraSession: data,
        isLoading,
        isError: !!error
    }
}
